/*-----------------------------------------------------------------------------/
/ Custom Theme JS - Linder Health
/-----------------------------------------------------------------------------*/

// Account Activation Form
// ---
// MiniOrange SSO still requires users to enter a password when connecting
// via SSO. Generate a random one automatically and submit. 
// The form is hidden via CSS.
function generateRandomString(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-0123456789";
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
jQuery(function($) {
    $activationForm = $('form[action="/account/activate"]');
    if ($activationForm.length) {
        var pw = generateRandomString(16);
        $('[type="password"]').val(pw);
        $('[type="submit"]', $activationForm).first().click();
    }
});

// PDP Module: Before & Aftters
// ---
jQuery(function($) {
    $('.pdp-single-ba').mousemove(function() {
        var width = $(this).width();
        var bounds = event.target.getBoundingClientRect();
        var x = event.clientX - bounds.left;
        var percent = x/width*100;
        if (percent < 0) { percent = 0; }
        if (percent > 100) { percent = 100; }
        $(this).first().attr('style', '--hover-percent: ' + percent.toFixed(1) + '%');
    });
});

// PDP Fix
// ---
jQuery(function($) {
    if ($('body').hasClass('template-product')) {
        setTimeout(function() {
            $('html').removeClass('sr');
        }, 2000);
    }
});